import React from 'react';
import { Modal, Button } from 'antd';

import './index.css';

class TipModal extends React.Component {
  render() {
    const { modalType } = this.props;
    return (
      <Modal
        title = "提示"
        visible = { modalType === "tip" && false }
        onCancel={ this.props.showModal.bind(this, "tipclose" ) }
        id="updateTipModal"
        footer={ <div className="text-right"><Button type="primary" onClick={ this.props.showModal.bind(this, "tipclose" ) }>关闭</Button></div>}
      >
        <div>缴费通后台系统于4月25日进行了更新，更新内容如下：</div>
        <div className="mt-16">
          <p>1.子账户子管理员功能修改</p>
          <p>在过去的运营中，我们发现子账户子管理员功能重合度较高，因而对此功能进行了升级。合并后原有的子管理员功能将无法新增和编辑，但现存的子管理员可以正常使用该功能。</p>
          <p>新的子账户管理中，管理员可以新增、编辑子管理员对各缴费项的编辑、查看权限，包含原有的子账户功能。</p>
          <p>2.对账单下载可以下载全部批次的账单。原本对账单下载仅能下载当前批次的账单，经过本次修改后，管理员可根据自己需要选择下载当前批次或者全部批次的账单。</p>
        </div>
        <div className="mt-16">历史更新记录</div>
        <div className="mt-16">
          <div>2019/3/25</div>
          <div>
            <p>1.缴费项支持多支付渠道（支付宝、微信、银联）缴费。</p>
            <p>管理员在创建缴费项时可以添加多个支付平台，每个平台可以关联一个收款账号。在该平台收到的金额将进入该平台关联的收款账号。例如管理员创建缴费项“学费”添加支付宝支付平台，关联收款账号123@yunban.com，则用户在支付宝校园卡以及通过支付宝扫码支付的金额，将进入123@yunban.com账号。</p>
            <p>对账单下载时，管理员可以下载某个收款账户或支付平台的全部对账单，也可以下载指定缴费项的某一支付平台的对账单。</p>
            <p>2.缴费通帮助中心上线。管理员可以在帮助中心中查看相关操作帮助。</p>

            <p>3.订单异常查询。如管理员发现有漏单现象，可在平台方（支付宝/微信）查询到该订单，输入商户订单号（以组织简码开头），点击处理进行处理，后台将自动查询该订单状态，如验证是漏单，则会自动更新该订单状态。无需再联系客服查询。</p>
          </div>
        </div>
      </Modal>
    )
  }
}

export default TipModal;



// WEBPACK FOOTER //
// ./src/index/tipModal.js